import dayjs from 'dayjs'
import _ from 'lodash'
import { fromJS, Map } from 'immutable'

export function getPartialStateToSave(state) {
  if (!state) return {}

  if (!state.stores?.selectedStore?.id) return {}

  return {
    profile: state.profile,
    stores: state.stores,
    // mySubScription: state.mySubScription,
    // subscription: state.subscription,
  }
}

export function getPersistedState(loadedState) {
  try {
    // const loadedState = loadState()

    // console.log('Loading typeof loadedState.stores.selectedStoreOrdersDates.begin', typeof loadedState.stores.selectedStoreOrdersDates.begin)
    if (loadedState && loadedState.stores && loadedState.stores.selectedStoreOrdersDates) {
      const begin = _.isString(loadedState.stores.selectedStoreOrdersDates.begin)
        ? dayjs(loadedState.stores.selectedStoreOrdersDates.begin)
        : loadedState.stores.selectedStoreOrdersDates.begin
      const end = _.isString(loadedState.stores.selectedStoreOrdersDates.end)
        ? dayjs(loadedState.stores.selectedStoreOrdersDates.end)
        : loadedState.stores.selectedStoreOrdersDates.end
      loadedState.stores.selectedStoreOrdersDates.begin = begin
      loadedState.stores.selectedStoreOrdersDates.end = end
    }

    if (loadedState && loadedState.stores && loadedState.stores.selectedStore) {
      loadedState.stores.selectedStore.isCache = true
    }
    console.log('Loading modified state', loadedState)

    let persistedState = fromJS(loadedState) || Map({})

    if (loadedState && loadedState.stores && loadedState.stores.selectedStoreOrdersDates) {
      persistedState = persistedState.setIn(['stores', 'selectedStoreOrdersDates'], {
        begin: loadedState.stores.selectedStoreOrdersDates.begin,
        end: loadedState.stores.selectedStoreOrdersDates.end,
      })
    }

    return persistedState
  } catch (e) {
    console.log('Error getting persisted state', e)
    return undefined
  }
}
